/* eslint-disable prefer-destructuring */
const $ = require('jquery')
const _ = require('underscore')
const Backbone = require('backbone')

const APP = require('APP')
const win = require('Helpers/win')
const user = require('Models/UserModel')
const GamePlayMessagesView = require('Views/GamePlay/GamePlayMessagesView')

require('UI/LoaderBg')
require('tpl')

module.exports = Backbone.View.extend({
  className: 'game-play-box',
  templateName: 'gamePlayTemplate',
  padding: [46, 0, 0, 0],

  initialize(options) {
    if (!options.messages) {
      // eslint-disable-next-line no-param-reassign
      options.messages = new GamePlayMessagesView(this, options.gameModel, options.forFun)
    }

    this.messages = options.messages

    this.forFun = options.forFun
    this.gameModel = options.gameModel
    this.format = this.gameModel.get('format')
    this.padding = options.padding !== undefined ? options.padding : this.padding

    this.sizes()
    this.render()
    this.showLoader()

    if (!this.model && this.modelConstructor) {
      // eslint-disable-next-line new-cap
      this.model = new this.modelConstructor(this, options.gameModel, this.messages)
    }

    if (this.messages) {
      this.messages.model = this.model
    }

    this.model.play()
  },

  sizes() {
    if (!this.padding) {
      this.padding = [0, 0, 0, 0]
    }
    if (_.isNumber(this.padding)) {
      this.padding = [this.padding[0], this.padding[0], this.padding[0], this.padding[0]]
    } else if (this.padding.length === 1) {
      this.padding = [this.padding[0], this.padding[0], this.padding[0], this.padding[0]]
    } else if (this.padding.length === 2) {
      this.padding = [this.padding[0], this.padding[1], this.padding[0], this.padding[1]]
    } else if (this.padding.length === 3) {
      this.padding = [this.padding[0], this.padding[1], this.padding[2], this.padding[1]]
    }

    if (!this.aspectRatio) {
      this.aspectRatio = 800 / 600
    }
  },

  render() {
    this.onResize()
    this.listenTo(win, 'resize', this.onResize)

    // desktop chrome / ff / android chrome
    window.addEventListener('beforeunload', this.onClose.bind(this), false)
    // mobile android / iOS
    window.addEventListener('unload', this.onClose.bind(this), false)
  },

  run() {
    this.hideLoader()
    this.show()
  },

  clearPlayBox() {},

  show() {
    if (this.isDestroyed === true) {
      return
    }
    this.$el.css('visibility', 'visible')

    win.$html.css('overflow-y', 'hidden')
    win.setSelectable(false)
  },

  hide() {
    this.$el.css('visibility', 'hidden')

    win.$html.css('overflow-y', '')
    win.setSelectable(true)
  },

  destroy() {
    this.hide()

    this.isDestroyed = true
    this.open = false

    // replaceShortcutIcons();

    if (this.vars) {
      this.vars.remove()
    }

    // win.off('resize', res);

    if (APP.isProvider === true) {
      // eslint-disable-next-line no-restricted-globals
      parent.postMessage('closeGame', '*') // router.path('game_popup'));
    }

    if (this.fixer) {
      this.fixer.remove()
    }

    if (this.gameLimits) {
      this.gameLimits.remove()
    }

    this.onClose()
    this.remove()
    this.trigger('destroy')

    try {
      window.closeGame()
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err)
    }
  },

  showLoader() {
    if (!this.$loader) {
      this.$loader = $('<div class="pf gameLoaderBox"></div>').css({
        width: '100%',
        height: '100%',
        zIndex: 104,
      })
      this.$loader.addLoader(true)

      this.$el.append(this.$loader)
    }
    this.$loader.show()
  },

  hideLoader() {
    this.$loader.hide()
  },

  onResize(e) {
    this.$el.css({
      width: win.width,
      height: win.height,
      marginTop: 0,
      marginLeft: 0,
    })

    if (_.isFunction(e)) {
      e()
    }

    setTimeout(() => {
      this.triggerResizeFunctionsCallbacks()
    }, 50)
  },

  triggerResizeFunctionsCallbacks() {
    _.forEach(this.onResizeFunctions, (onResizeFn) => {
      try {
        console.log('trigger on resize fn') // eslint-disable-line
        onResizeFn()
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err)
      }
    })
  },

  registerOnResize(f) {
    if (_.isFunction(f)) {
      if (!_.isArray(this.onResizeFunctions)) {
        this.onResizeFunctions = []
      }
      this.onResizeFunctions.push(f)
    }
  },

  getScreenshot() {
    return false
  },

  onClose(callback) {
    if (!APP.isProvider) {
      this.model.sendCloseMsg(() => {
        user.sync()
        if (_.isFunction(callback)) {
          callback()
        }
      })
    }
  },
})

window.closeGame = function closeGame() {
  // alert('closeGame')
}
